import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function WalletReviewsSkeleton() {
    return (
        <section
            className="review-section section-bg pb-60"
            style={{ height: "280px", overflow: "hidden" }}
        >
            <div className="container wallet-container">
                <div className="row">
                    <div className="col-sm-1"></div>
                    <div className="col-sm-11">
                        <div
                            className="review-slider-wrapper tw-stretch-element-inside-column"
                            style={{
                                marginLeft: "0px",
                                marginRight: "-308px",
                                display: "flex",
                                gap: "20px",
                                overflow: "hidden",
                            }}
                        >
                            {[...Array(4)].map((_, idx) => (
                                <div
                                    key={idx}
                                    className="review-item"
                                    style={{
                                        minWidth: "280px",
                                        padding: "20px",
                                        borderRadius: "12px",
                                        background: "#fff",
                                    }}
                                >
                                    <div className="review-item__top mb-2">
                                        <Skeleton height={20} width="60%" className="mb-2" />
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            {[...Array(5)].map((_, star) => (
                                                <Skeleton
                                                    key={star}
                                                    height={16}
                                                    width={16}
                                                    borderRadius={4}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                    <Skeleton height={48} className="mb-2" />
                                    <Skeleton height={16} width="40%" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
